<template>
  <div class="baseform">
    <div class="form" style="margin-top:300px;">
      <!-- 登录tittle -->
      <h2>
        <span>中国华西企业股份有限公司</span>
      </h2>
      <!-- 中间填写区域 -->
      <div class="form-area">
        <!-- 短信登录 -->
        <div class="title">
          <span>BIM中心</span>
        </div>
        <!-- 账号 -->
        <div class="form-item name">
          <input type="text" name="username" placeholder="请输入账号" maxlength="14" v-model="loginForm.account" />
        </div>
        <!-- 密码 -->
        <div class="form-item pwd">
          <input type="password" name="password" placeholder="请输入密码" maxlength="14" v-model="loginForm.passWord" />
        </div>
        <!-- 登录按钮 -->
        <div class="form-item login">
          <button @click="submitForm">登录</button>
        </div>
        <!-- 忘记密码 -->
        <div style="display:flex; margin-top: 15px;">
          <p id="forget" @click="forgetaccount">忘记密码？</p>
          <p id="registcount" @click="dialogVisible = true">立即注册</p>

        </div>
        <div class="form-item login">
          <button @click="lighttest">轻量化测试</button>
        </div>
        <!-- 其他登录方式和注册 -->

      </div>
      <!--新建/修改窗口-->
      <el-dialog title="用户注册" :visible.sync="dialogVisible" width="500px">
        <el-form ref="regist" v-model="regist" :rules="rules" label-width="80px" label-position="left"
          style="text-align:left; ">
          <el-form-item label="账号">
            <el-input v-model="regist.account" placeholder="输入账号"></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="regist.name" placeholder="输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="regist.passWord" placeholder="输入密码"></el-input>
          </el-form-item>
          <el-form-item label="重复密码">
            <el-input v-model="regist.repassWord" placeholder="重复输入密码"></el-input>
          </el-form-item>
          <el-form-item label="岗位类型">
            <el-radio-group v-model="regist.worktype">
              <el-radio label="前台"></el-radio>
              <el-radio label="中台"></el-radio>
              <el-radio label="后台"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button class="button" type="primary" @click="registaccount" style="margin-right:20px ;">立即创建</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!--新建/修改窗口-->
    </div>
  </div>

</template>

<style scoped>
.baseform {
  background-image: url(../image/Login/login.jpg);
  background-size: cover;
  height: 100%;
  width: 100%;
  color: #656262;
}

.form {
  width: 500px;
  height: 450px;
  background: #fff;
  margin: 80px auto;
  box-shadow: 10px 10px 10px rgba(57, 56, 56, 0.9);
  border: 1px solid rgb(0, 0, 0);
  border-radius: 14px;
}

h2 {
  padding-top: 32px;
  font-size: 30px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  height: 22px;
  margin-bottom: 60px;
  color: #656262;
}

h2 span {
  background-color: #fff;
  padding: 0 20px;
  font-weight: 700;
}

.form-area {
  width: 400px;
  margin: 0 auto;
}

.title {
  text-align: center;
  font-weight: 600;
  font-size: 28px;
  padding: 10px 0;
  margin-top: -40px;
  margin-bottom: 10px;
}

.title a {
  color: #3b97b7;
}

.form-item {
  width: 400px;
  height: 42px;
  position: relative;
}

input {
  width: 400px;
  height: 40px;
  border: 0;
  outline: none;
  text-indent: 16px;
  font-size: 17px;
  color: #606266;
  border-radius: 5px;
  border: 1px solid #9e9e9e;
}

input::placeholder {
  font-size: 15px;
  color: #ccc;
}

.clear {
  position: absolute;
  right: 15px;
  top: 9px;
  color: #ccc;
  cursor: pointer;
}

.name input {
  border-radius: 5px 5px 0 0;

}

.pwd input {
  margin-top: 20px;
  border-radius: 0 0 5px 5px;
}

.form-item.login {
  margin-top: 50px;
  border-radius: 5px;
}

.form-item button {
  width: 101%;
  height: 101%;
  font-size: 18px;
  border: 0;
  outline: none;
  background-color: #009933;
  color: #fff;
  border-radius: 5px;
}

.form-item button:hover {
  background-color: #037d2c;
}

.forget {
  margin-top: 20px;
  font-size: 15px;
  text-align: left;
}

.forget a {
  color: #9e9e9e;
}

.regist {
  height: 70px;
  background: #eeeeee;
  line-height: 70px;
}

.regist span {
  color: #009933;
  padding-left: 20px;
}

.regist a {
  color: #009933;
  padding-left: 180px;
}

#registcount {
  margin-left: 64%;
  text-decoration: underline;
  cursor: pointer;
  color: #3b97b7;
}

#forget {
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
  color: #3b97b7;
}
.demo{
        display: inline-block;
        width: 600px;
        height: 600px;
        text-align: center;
        line-height: 100px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #552323;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
  }
 
  .demo:hover{
   		display: block;
  }
</style>

<script>
export default {
  name: "Login",
  data: function () {
    return {

      loginForm: {
        account: "",
        passWord: "",


      },
      loginRules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      dialogVisible: false,
      regist: {
        account: '',
        passWord: '',
        name: '',
        repassWord: '',
        worktype: '前台'
      },
    };
  },

  methods: {
    submitForm() {
      const userAccount = this.loginForm.account;
      const userPassword = this.loginForm.passWord;
      if (!userAccount) {
        return this.$message({
          type: "error",
          message: "账号不能为空！",
        });
      }
      if (!userPassword) {
        return this.$message({
          type: "error",
          message: "密码不能为空！",
        });
      }
      console.log("用户输入的账号为：", userAccount);
      console.log("用户输入的密码为：", userPassword);
      this.$axios({
        url: this.apiurl +
          "UserLogin/Cheaklogininfo?account=" + userAccount +
          '&password=' + userPassword
      }).then((res) => {
        if (res.data) {
          this.$store.state.userid = userAccount;
          //根据账户获取用户信息
          this.$axios({
      url: this.apiurl +
        "UserLogin/GetUserInfoById?account=" + userAccount
    }).then((res) => {
      if (res.status == 200) {
        this.$store.state.userinfo.userid = res.data.id;
        this.$store.state.userinfo.username = res.data.name;
        this.$store.state.userinfo.userpassword = res.data.password;
        this.$store.state.userinfo.userposition = res.data.position;
        this.$axios({
      url: this.apiurl +
        "UserWork/GetReportWorkByLoinName?name=" + this.$store.state.userinfo.username
    }).then((res) => {
      if (res.status == 200) {
        this.$store.state.useruncheckmessage=[];
          this.$store.state.usermessage=[];
        res.data.forEach(element => {
            let workinfo = {
            JsWorkid: element.workId,
            JsCheckname: element.checkName,
            JsContent: element.content,
            JsIsagree: element.isAgree,
            JsMessage:element.message,
            JsRecivitime:element.reciviTime,
            JsReportername:element.reporterName,
            JsReporterTime:element.reporterTime,
            JsWorkId:element.workId,
            JsWorkType:element.workType
          };
          
          this.$store.state.usermessage.push(workinfo);    
          if(workinfo.JsIsagree==0)
          {
            this.$store.state.useruncheckmessage.push(workinfo);            
          };     
        
        });
        this.$store.state.useruncheckmessagenumber = this.$store.state.useruncheckmessage.length;
        this.$router.push('/home');
      }
      else {
        alert("错误！")
      }
    }, (err) => {
      console.log(err.message);
    });
      }
      else {
        alert("错误！")
      }
    }, (err) => {
      console.log(err.message);
    });
    console.log(this.$store.state.userinfo);
          
          console.log(this.$store.state.useruncheckmessagenumber);
          console.log( this.$store.state.useruncheckmessage);
          
        }
        else {
          alert("密码错误！")
        }
      }, (err) => {
        console.log(err.message);
      });
    },
    registaccount() {
      this.$axios({
        url: this.apiurl +
          "UserLogin/Registaccount?id=" + this.regist.account +
          '&name=' + this.regist.name +
          '&password=' + this.regist.passWord +
          '&position=' + this.regist.worktype
      }).then((res) => {
        alert("注册成功");
      }, (err) => {
        console.log(err.message);
      });
    },
    forgetaccount() {
      this.$alert('测试版不提供此功能，请联系中端管理员找回密码', '提示', {
          confirmButtonText: '确定',          
        });
    },
    lighttest(){
      this.$router.push('/home');
    }
  },
  
  // 生命周期 - 创建完成
  created() { },
  beforeCreate() { },
  beforeDestroy() { }
}
</script>

  